/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PriceDisplay_item = {
    readonly activeHold: {
        readonly displayTimeToExpire: string | null;
    } | null;
    readonly pricing: {
        readonly percentageOff: {
            readonly salePrice: string | null;
            readonly netPrice: string | null;
        } | null;
        readonly saleOriginPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
        readonly retailPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
        readonly salePrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
        readonly netPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
    } | null;
    readonly lastActiveTransaction?: {
        readonly summary: {
            readonly retailPrice: {
                readonly amount: {
                    readonly convertedAmountList: ReadonlyArray<{
                        readonly currency: Currency | null;
                        readonly amount: number | null;
                    } | null> | null;
                } | null;
            } | null;
            readonly salePrice: {
                readonly amount: {
                    readonly convertedAmountList: ReadonlyArray<{
                        readonly currency: Currency | null;
                        readonly amount: number | null;
                    } | null> | null;
                } | null;
            } | null;
            readonly netPrice: {
                readonly amount: {
                    readonly convertedAmountList: ReadonlyArray<{
                        readonly currency: Currency | null;
                        readonly amount: number | null;
                    } | null> | null;
                } | null;
            } | null;
        } | null;
        readonly isPrivateOffer: boolean | null;
        readonly offers: ReadonlyArray<{
            readonly canUseOfferForCheckout: boolean | null;
            readonly expirationDate: string | null;
            readonly amountPerItem: {
                readonly convertedAmountList: ReadonlyArray<{
                    readonly currency: Currency | null;
                    readonly amount: number | null;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PriceDisplay_item";
};
export type PriceDisplay_item$data = PriceDisplay_item;
export type PriceDisplay_item$key = {
    readonly " $data"?: PriceDisplay_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PriceDisplay_item">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "convertedAmountList",
    "storageKey": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
      }
    ]
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "amount",
    "storageKey": null,
    "args": null,
    "concreteType": "FinancialAmount",
    "plural": false,
    "selections": (v0/*: any*/)
  }
];
return {
  "kind": "Fragment",
  "name": "PriceDisplay_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "activeHold",
      "storageKey": null,
      "args": null,
      "concreteType": "Hold",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayTimeToExpire",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "percentageOff",
          "storageKey": null,
          "args": null,
          "concreteType": "PercentageOff",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "salePrice",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "netPrice",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "saleOriginPrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "retailPrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "salePrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "netPrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "lastActiveTransaction",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "concreteType": "Transaction",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "summary",
              "storageKey": null,
              "args": null,
              "concreteType": "TransactionSummaryObject",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "retailPrice",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Price",
                  "plural": false,
                  "selections": (v1/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "salePrice",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Price",
                  "plural": false,
                  "selections": (v1/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "netPrice",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Price",
                  "plural": false,
                  "selections": (v1/*: any*/)
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isPrivateOffer",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "offers",
              "storageKey": null,
              "args": null,
              "concreteType": "Offer",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "canUseOfferForCheckout",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "expirationDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "amountPerItem",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "plural": false,
                  "selections": (v0/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '35cc5de3cf306e0907b052a4825d5199';
export default node;
